var React = require('react');

function AboutInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.158,26.134C6.066,23.557,5,21,5,21l7,2c0,0-3.663,3.721-8.417,3.99L3.158,26.134z","key":0}),React.createElement("circle",{"cx":"3.5","cy":"26.5","r":"0.5","key":1}),React.createElement("path",{"d":"M15,3C7.82,3,2,7.925,2,14s5.82,11,13,11s13-4.925,13-11S22.18,3,15,3z M16,20h-2v-7h2V20z M15,10.5  c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S15.828,10.5,15,10.5z","key":2})]);
}

AboutInline.defaultProps = {"id":"Layer_1","fill":"rgba(250, 223, 99, 1)","style":{"enableBackground":"new 0 0 30 30"},"version":"1.1","viewBox":"0 0 30 30","xmlSpace":"preserve"};

module.exports = AboutInline;

AboutInline.default = AboutInline;
